import { useState } from "react";
import { T } from "../theme";
import LoadingSpinner from "./LoadingSpinner";

const variants = {
  primary: {
    background: T.gradientAccent,
    color: "#fff",
    border: "none",
    shadow: "0 2px 8px rgba(99,102,241,0.25)",
    hoverShadow: "0 4px 16px rgba(99,102,241,0.35)",
  },
  secondary: {
    background: T.bgCard,
    color: T.textMid,
    border: `1px solid ${T.border}`,
    shadow: "none",
    hoverShadow: T.shadowCard,
  },
  ghost: {
    background: "transparent",
    color: T.textMid,
    border: "1px solid transparent",
    shadow: "none",
    hoverShadow: "none",
  },
  danger: {
    background: T.red,
    color: "#fff",
    border: "none",
    shadow: "0 2px 8px rgba(239,68,68,0.25)",
    hoverShadow: "0 4px 16px rgba(239,68,68,0.35)",
  },
};

const sizeStyles = {
  sm: { padding: "6px 12px", fontSize: 13, iconSize: 14 },
  md: { padding: "10px 18px", fontSize: 14, iconSize: 16 },
  lg: { padding: "12px 24px", fontSize: 15, iconSize: 18 },
};

export default function Button({
  variant = "primary",
  size = "md",
  icon: Icon,
  loading = false,
  disabled = false,
  fullWidth = false,
  children,
  onClick,
  style,
}) {
  const [hovered, setHovered] = useState(false);
  const v = variants[variant] || variants.primary;
  const s = sizeStyles[size] || sizeStyles.md;

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: s.padding,
        fontSize: s.fontSize,
        fontWeight: 600,
        fontFamily: T.fontBody,
        borderRadius: T.radiusSm,
        background: v.background,
        color: v.color,
        border: v.border,
        boxShadow: hovered && !disabled ? v.hoverShadow : v.shadow,
        transform: hovered && !disabled && variant === "primary" ? "translateY(-1px)" : "none",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: T.transitionFast,
        width: fullWidth ? "100%" : undefined,
        whiteSpace: "nowrap",
        outline: "none",
        ...(hovered && !disabled && variant === "secondary" ? { background: T.bgBase } : {}),
        ...(hovered && !disabled && variant === "ghost" ? { background: T.bgInput } : {}),
        ...style,
      }}
    >
      {loading ? (
        <LoadingSpinner size="sm" />
      ) : (
        <>
          {Icon && <Icon size={s.iconSize} />}
          {children}
        </>
      )}
    </button>
  );
}
